<template>
	<v-col cols="12" ref="fsRoot" class="fs-surface">
		<!-- <v-row ref="fsHeader" class="mt-2" align="center" no-gutters>
			<v-col cols="12" class="d-flex justify-end">
				<v-btn color="primary" @click="extenderPantalla">
				<v-icon left>{{ fsIcon }}</v-icon>
				{{ fsLabel }}
				</v-btn>
			</v-col>
		</v-row> -->

			<v-col cols="12" ref="projection" class="projection-wrap">
			<v-progress-linear v-if="cargando" color="primary" height="5" indeterminate />
				<div class="text-center font-weight-bold mb-2 titulo-area">
					Eficiencia Operadores del Área: {{ areaConsultadaNombre }}
				</div>
				<div class="text-center font-weight-bold mb-2 titulo-area">
					Rango Consultado: {{ rangoFechasLabel }}
				</div>
			<div class="apexchart-padding">
				<apexchart
					ref="apex"
					type="bar"
					:height="chartHeight"
					:options="chartOptions"
					:series="series"
				/>
			</div>
			</v-col>
	</v-col>
</template>

<script>
import axios from "axios";
import { mapState } from 'vuex';
import moment from 'moment';
export default {
	data() {
		return {
			categories: [],
			series: [],
			desde: null,
			hasta: null,
			idArea: null,
			areas: [],
			idTurno: null,
			turnos: [],
			idsPersonas: [],
			personas: [],
			cargando: false,
			reportes: [],
			cargandoTable: false,
			infoDetalle: false,
			rowsRaw: [],
			opIdsByBarIndex: [],
			opNameByBarIndex: [],
			selectedOpId: null,
			selectedOpName: "",
			idOperacionReal : null,
			inicio : null,
			fin: null,
			dialogEditHour : false,
			loadSave: false,
			historialEdiciones: [],
			puedeGuardarFechas: false,
			vista: "eficiencia",          // 'eficiencia' | 'historial'
			cargandoHistorial: false,
			personasHistorial: [],
			//historialHeaders: [],
			//historialItems: [],
			selectedHistOpId: null,
   			selectedHistOpName: "",
			cargandoFechas: false,
			historialReady: false,
			_reqKey: 0,
			_fechasTimer: null,
			paroDialogKey: 0,
			tipoParos: [],
			tipoSubparos: [],
			dialogEditParo: false,
			loadSaveParo: false,
			paroInicio: null,
			paroFin: null,
			paroCausa: null,
			showStickyXScroll: false,
			_syncingX: false,
			_onResize: null,
			historialDiasItems: [],
			idsOperadoresReporte: [],
			mapOperadorNombre: {},   // idPersona => "Nombre Apellido"
			idsByCategory: [],            // lo usas en dataPointSelection
			idsByHistCategory: [],
			carrusel: {
				enabled: true,
				segundos: 20,
				timer: null,
				idx: 0,
				areasRotacion: [6, 9, 11], // ids de áreas
			},
			chartHeight: 550,
  			_onFsResize: null,
			_syncFs: null,
			_ro: null,
			isFullscreen: false,
			chartOptions: {
				chart: {
					type: "bar",
					height: 550,
					zoom: {
						enabled: true,
					},
				},
				dataLabels: {
					enabled: false,
				},
				colors: [() => this.getColor()],
				markers: {
					size: 1,
				},
				stroke: {
					show: true,
					width: 2,
					colors: ["transparent"],
				},
				xaxis: {
					categories: [],
					labels: {
						rotate: -20,
						style: {
							fontSize: "26px",
							fontWeight: 700,
						},
					},
				},
				fill: {
					opacity: 1,
				},
			},
			chartOptionsDefault: {
				chart: { type: "bar", height: 550, zoom: { enabled: true } },

				plotOptions: {
					bar: {
					  dataLabels: {
						position: "top", // top, center, bottom
					  },
					},
				},
				dataLabels: {
					enabled: true,
					formatter: function (val) {
					const n = Number(val);
  					return Number.isFinite(n) ? n.toFixed(2) + " %" : "—";
					},
					offsetY: -14,
					style: {
						colors: ["#000"],
						fontSize: '20px',
						fontWeight: 700,
					},
				},
				colors: [() => this.getColor()],
				markers: { size: 1 },
				stroke: { show: true, width: 2, colors: ["transparent"] },

				xaxis: {
					categories: [],
					labels: {
						rotate: -20,
						style: {
							fontSize: "26px",
							fontWeight: 700,
						},
					},
				},

				yaxis: {
					labels: {
						formatter: function (val) {
							const n = Number(val);
      						return Number.isFinite(n) ? n.toFixed(2) + " %" : "—";
						},
					},
				},

				tooltip: {
					y: {
						formatter: function (val) {
							const n = Number(val);
							return Number.isFinite(n) ? n.toFixed(2) + " %" : "—";
						},
					},
				},
				fill: { opacity: 1 },
			},
			historialSeries: [{ name: "Calificación", data: [] }],
			colors: [
				"#008FFB",
				"#00E396",
				"#FEB019",
				"#FF4560",
				"#775DD0",
				"#4CAF50",
				"#FF9800",
				"#1B998B",
				"#FA4443",
				"#A300D6",
			],
			colorsDummy: [
				"#008FFB",
				"#00E396",
				"#FEB019",
				"#FF4560",
				"#775DD0",
				"#4CAF50",
				"#FF9800",
				"#1B998B",
				"#FA4443",
				"#A300D6",
			],
		};
	},
	mounted() {
		this.initialize();
		this.setRangoSemanaPasadaLaboral();
		this.idArea = this.carrusel.areasRotacion[0];
		this.onFechasChange();
		this.startCarrusel();

		const sync = () => {
			this.isFullscreen = !!(document.fullscreenElement ||
			document.webkitFullscreenElement ||
			document.msFullscreenElement);

			this.$nextTick(() => this._applyChartSize());
		};

		document.addEventListener('fullscreenchange', sync);
		document.addEventListener('webkitfullscreenchange', sync);
		document.addEventListener('MSFullscreenChange', sync);
		this._syncFs = sync;

		this._onFsResize = () => this._applyChartSize();
		window.addEventListener('resize', this._onFsResize);

		const root = this.$refs.fsRoot?.$el || this.$refs.fsRoot;
		if (root && window.ResizeObserver) {
			this._ro = new ResizeObserver(() => this._applyChartSize());
			this._ro.observe(root);
		}

		sync();
		this.$nextTick(() => this._applyChartSize());
		},
	computed:{
		...mapState(["token","nuevoReporteOee", 'nombreEmpresa']),
		isTamto(){
			const n = (this.nombreEmpresa || '')
			return n === 'TAMTO';
		},
		fsLabel() { return this.isFullscreen ? 'Salir de Pantalla' : 'Extender Pantalla'; },
    	fsIcon()  { return this.isFullscreen ? 'mdi-arrow-collapse-all' : 'mdi-arrow-expand-all'; },
		areaConsultadaNombre() {
			const a = (this.areas || []).find(x => Number(x.idArea) === Number(this.idArea));
			return a?.nombre || (this.idArea ? `ID ${this.idArea}` : "");
		},
		rangoFechasLabel() {
			const fmt = (v) => {
			if (!v) return null;
			const m = moment(String(v).trim(), ["YYYY-MM-DD", "YYYY-MM-DD HH:mm:ss", moment.ISO_8601], true);
			return m.isValid() ? m.format("DD/MM/YYYY") : null;
			};

			const d = fmt(this.desde);
			const h = fmt(this.hasta);

			if (!d || !h) return "—";
			return `${d} al ${h}`;
		},
	},
	beforeDestroy() {
		this.stopCarrusel();
		if (this._ro) this._ro.disconnect();
		if (this._onFsResize) window.removeEventListener("resize", this._onFsResize);
		if (this._syncFs) {
      document.removeEventListener('fullscreenchange', this._syncFs);
      document.removeEventListener('webkitfullscreenchange', this._syncFs);
      document.removeEventListener('MSFullscreenChange', this._syncFs);
    }
	},
	watch: {
		vista() {
			this.onFechasChange();
		},
		desde() { if (this.vista === "historial") this.obtenerHistorialEdiciones(); },
		hasta() { if (this.vista === "historial") this.obtenerHistorialEdiciones(); },
		idsPersonas() { if (this.vista === "historial") this.obtenerHistorialEdiciones(); },
		inicio() { this.puedeGuardarFechas = this.validar(); },
		fin()    { this.puedeGuardarFechas = this.validar(); },
	},	
	methods: {
		getColor() {
			if (this.colorsDummy.length == 0) {
				this.colorsDummy = this.colors.map((color) => color);
			}
			return this.colorsDummy.pop();
		},
		nombrePersona: (persona) =>
			persona.nombre + " " + persona.paterno + " " + persona.materno,

		getPersonas() {
			if (!this.desde || !this.hasta) {
				this.resetValues();
				return Promise.resolve([]); // importante para que await no truene
			}

			this.idsPersonas = [];
			this.personas = [];

			return axios
				.get("/Personas/OperadoresRendimientoIntervalo", {
				params: { desde: this.desde, hasta: this.hasta },
				})
				.then((response) => {
				const raw = response.data || [];
				const uniq = new Map();

				for (const p of raw) {
					const id = p.idPersona ?? p.IdPersona;
					if (!id) continue;
					if (!uniq.has(id)) {
					uniq.set(id, {
						idPersona: id,
						nombre: p.nombre ?? p.Nombre ?? "",
						paterno: p.paterno ?? p.Paterno ?? "",
						materno: p.materno ?? p.Materno ?? "",
					});
					}
				}

				this.personas = Array.from(uniq.values());
				return this.personas;
				})
				.catch((error) => {
				console.log(error);
			});
		},
		resetValues() {
			this.personas = [];
			this.idsPersonas = [];
			this.categories = [];
			this.series = [];
			this.chartOptions = Object.assign({},this.chartOptionsDefault);
			this.chartOptions.xaxis.categories = [];
			this.colorsDummy = this.colors.map((color) => color);
		},
		initialize() {
			this.getAreas();
			this.getTurnos();
		},
		getAreas() {
			axios
				.get("/Areas")
				.then((response) => {
					this.areas = response.data.filter(
						(area) => area.idArea > 1
					);
				})
				.catch((error) => {
					console.log(error);
				});
		},
		getTurnos() {
			axios
				.get("/Turnos")
				.then((response) => {
					this.turnos = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		getEficienciaValue(row) {
			const v = row?.eficiencia;
			if (v === null || v === undefined) return null;
			const n = typeof v === 'string' ? parseFloat(v.replace('%','')) : v;
			if (!Number.isFinite(n)) return null;
			if (n > 3000000 || n < 0) return null;
			return n;
		},

		// Promedio simple por operador (incluye 0 reales, excluye "sin dato")
		// Promedio simple por operador usando idsOperadores[0] (1 operador)
		// Regresa SIEMPRE { categories: [], series: [{ name, data: [] }] }
		agruparPromedioSimple(rows, idsPermitidos, { incluirCeros = true } = {}) {
			const set = idsPermitidos?.length ? new Set(idsPermitidos) : null;
			const map = new Map(); // id => { sum, n }

			for (const r of (rows || [])) {
				const id = Array.isArray(r.idsOperadores) ? r.idsOperadores[0] : null;
				if (!id) continue;

				if (set && !set.has(id)) continue;

				const eff = this.getEficienciaValue(r);
				if (eff === null) continue;
				if (!incluirCeros && eff === 0) continue;

				const acc = map.get(id) ?? { sum: 0, n: 0 };
				acc.sum += eff;
				acc.n += 1;
				map.set(id, acc);
			}

			return map;
		},

		buildParamsSubpasos() {
			const p = { desde: this.desde, hasta: this.hasta };
			if (this.idTurno)  p.idsTurnos  = [this.idTurno];
			if (this.idArea)   p.idsAreas   = [this.idArea];
			if (this.idsPersonas?.length) p.idsPersonas = this.idsPersonas;
			return p;
		},

		setOperadoresDesdeRows(rows) {
			const ids = new Set();
			const map = new Map();

			for (const r of (rows || [])) {
				const idsOps = Array.isArray(r.idsOperadores) ? r.idsOperadores : [];
				const names  = Array.isArray(r.operadores) ? r.operadores : [];

				idsOps.forEach((id, idx) => {
				if (!id) return;
				ids.add(id);

				const nombre = (names[idx] || names[0] || "").trim();
				if (nombre && !map.has(id)) map.set(id, nombre);
				});
			}

			this.idsOperadoresReporte = Array.from(ids);
			this.mapOperadorNombre = map;
		},

		resetColorsDummy() {
			const base = Array.isArray(this.colors) ? this.colors : [];
			this.colorsDummy = base.slice(); // copia segura
		},
		formatearPromedioDesdeMap(avgMap) {
			let entries = [];

			if (avgMap instanceof Map) {
				entries = Array.from(avgMap.entries());
			} else if (avgMap && typeof avgMap === "object") {
				entries = Object.entries(avgMap);
			} else {
				entries = [];
			}

			const safe2 = (x) => {
				const n = Number(x);
				if (!Number.isFinite(n)) return 0;          // evita NaN/Infinity
				return Number(n.toFixed(2));                // regresa number (no string)
			};

			return entries
				.map(([idRaw, acc]) => {
				const id = Number(idRaw);

				const sum = Number(acc?.sum ?? acc?.sumEff ?? 0);
				const n   = Number(acc?.n   ?? acc?.nConDato ?? 0);

				const prom = (Number.isFinite(sum) && Number.isFinite(n) && n > 0)
					? (sum / n)
					: 0;

				const name =
					(this.mapOperadorNombre instanceof Map && this.mapOperadorNombre.get(id))
					? this.mapOperadorNombre.get(id)
					: `ID ${id}`;

				return { id, name, value: safe2(prom) };
				})
				.filter(x => Number.isFinite(x.id));
		},

		async obtenerDatos() {
			if (!this.desde || !this.hasta || this.cargando) {
				this.resetValues();
				this.idArea = null;
				this.idTurno = null;
				return [];
			}

			this.cargando = true;
			try {
				// ============================================================
				// ======================= FLUJO TAMTO =========================
				// ============================================================
				if (this.isTamto) {
				const p = this.buildParamsSubpasos();

				const sp = new URLSearchParams();
				for (const [k, v] of Object.entries(p)) {
					if (Array.isArray(v)) v.forEach(x => sp.append(k, x));
					else if (v !== null && v !== undefined) sp.append(k, v);
				}

				const resp = await axios.get("/Reportes/ReporteCalidadSubpasos?" + sp.toString());
				const rowsRaw = Array.isArray(resp.data) ? resp.data : (resp.data?.filas || []);

				// normaliza eficiencia a número (solo para poder promediar)
				const toNum = (v) => {
					if (v === null || v === undefined) return null;
					if (typeof v === "string") {
					const n = parseFloat(v.replace("%", "").trim());
					return Number.isFinite(n) ? n : null;
					}
					return Number.isFinite(v) ? v : null;
				};

				const rows = rowsRaw.map(r => ({ ...r, eficiencia: toNum(r.eficiencia) }));

				// mapa id->nombre para pintar categorías bonitas en el chart
				this.setOperadoresDesdeRows(rows);

				// promedio simple por operador (tu función)
				const avgMap = this.agruparPromedioSimple(rows, this.idsPersonas, { incluirCeros: false });

				// [{id, name, value}]
				const paired = this.formatearPromedioDesdeMap(avgMap)
					.sort((a, b) => b.value - a.value);

				const chartOptions = JSON.parse(JSON.stringify(this.chartOptionsDefault));
				this.resetColorsDummy?.(); // o this.colorsDummy = this.colors.slice()
				chartOptions.colors = [() => this.getColor()];

				chartOptions.xaxis = chartOptions.xaxis || {};
				chartOptions.xaxis.categories = paired.map(p => p.name);
				chartOptions.chart = chartOptions.chart || {};
				chartOptions.chart.height = this.chartHeight;

				this.chartOptions = chartOptions;
				this.series = [{
				name: "Eficiencia",
				data: paired.map(p => Number(p.value)).map(v => (Number.isFinite(v) ? v : 0)),
				}];
				this.$nextTick(() => {
				if (this.isFullscreen) this._applyChartSize();

				// fuerza a Apex a recalcular layout
				const comp = this.$refs.apex;
				const chartObj = comp?.chart || comp?.chartObj;
				chartObj?.resize?.();
				});
				this.cargando = false;
				return paired; // o return rows; como prefieras
				}

				// ============================================================
				// ===================== FLUJO ORIGINAL =======================
				// ============================================================
				let url = this.nuevoReporteOee
				? "/Reportes/ReporteEficienciaOperadorOEE"
				: "/Reportes/ReporteEficienciaOperador";

				if (Array.isArray(this.idsPersonas) && this.idsPersonas.length > 0) {
				this.idsPersonas.forEach((persona, idx) => {
					url += idx === 0 ? `?idsOperadores=${persona}` : `&idsOperadores=${persona}`;
				});
				}

				const resp2 = await axios.get(url, {
				params: {
					desde: this.desde,
					hasta: this.hasta,
					idArea: this.idArea,
					idTurno: this.idTurno,
				},
				});
				const chartOptions2 = Object.assign({}, this.chartOptionsDefault);
				this.colorsDummy = this.colors.map(c => c);
				chartOptions2.colors = [() => this.getColor()];
				chartOptions2.xaxis = chartOptions2.xaxis || {};
				chartOptions2.xaxis.categories = resp2.data?.operadores || [];

				this.chartOptions = chartOptions2;
				this.series = resp2.data?.series || [];

				this.cargando = false;
				return resp2.data;

			} catch (error) {
				console.log(error);
				this.cargando = false;
				this.series = [];
				this.colorsDummy = this.colors.map(c => c);
				return [];
			}
			},
		onFechasInput() {
			clearTimeout(this._fechasTimer);
			this._fechasTimer = setTimeout(() => {
			this.onFechasChange();
			}, 150);
		},
		formatDia(dia) {
			// dia viene como "YYYY-MM-DD"
			return moment(dia, "YYYY-MM-DD").format("DD/MM/YYYY");
		},
		formatFechaHora(v) {
			if (!v) return "—";

			const m = moment(String(v).trim(), [
				moment.ISO_8601,
				"YYYY-MM-DD HH:mm",
				"YYYY-MM-DD HH:mm:ss",
				"YYYY-MM-DD"
			], true);

			return m.isValid() ? m.format("YYYY-MM-DD HH:mm") : "—";
		},
		setRangoSemanaPasadaLaboral() {
			const lunesEstaSemana = moment().startOf('isoWeek');       // lunes actual
			const lunesPasado = lunesEstaSemana.clone().subtract(1, 'week');
			const viernesPasado = lunesPasado.clone().add(4, 'days');  // +4 => viernes

			this.desde = lunesPasado.format("YYYY-MM-DD");
			this.hasta = viernesPasado.format("YYYY-MM-DD");
			},

		startCarrusel() {
			this.stopCarrusel();
			if (!this.carrusel?.enabled) return;

			// seguridad: solo ids válidos
			const list = (this.carrusel.areasRotacion || []).filter(n => Number.isFinite(+n));
			if (!list.length) return;

			this.carrusel.timer = setInterval(() => {
				// evita encimar requests
				if (this.cargando) return;

				// (opcional) por si quieres re-fijar semana pasada cada vuelta
				// this.setRangoSemanaPasadaLaboral();

				this.carrusel.idx = (this.carrusel.idx + 1) % list.length;
				this.idArea = list[this.carrusel.idx];

				// refresca el mismo reporte, mismo componente
				this.refrescarVista();
			}, (this.carrusel.segundos || 20) * 1000);
		},

		stopCarrusel() {
			if (this.carrusel?.timer) clearInterval(this.carrusel.timer);
			if (this.carrusel) this.carrusel.timer = null;
		},
		refrescarVista() {
			if (!this.desde || !this.hasta) {
			// limpia todo si no hay rango
			this.series = [];
			this.historialEdiciones = [];
			return;
			}

			if (this.vista === 'eficiencia') this.obtenerDatos();
			else this.obtenerHistorialEdiciones();
		},
		async onFechasChange() {
			if (!this.desde || !this.hasta) return;

			const rid = (this._ridFechas = (this._ridFechas || 0) + 1);

			await this.getPersonas();
			if (rid !== this._ridFechas) return;

			await this.obtenerDatos();              // aquí setOperadoresDesdeRows(rows)
			if (rid !== this._ridFechas) return;
		},
		getTipoParos() {
			axios
				.get("/ParoTipos")
				.then((response) => {
				this.tipoParos = response.data;
				})
				.catch((error) => {
				console.log(error);
				});
		},
		getTipoSubParos() {
			axios
				.get("/SubParoTipos")
				.then((response) => {
				this.tipoSubparos = response.data;
				})
				.catch((error) => {
				console.log(error);
				});
		},
		_projectionEl() {
			const ref = this.$refs.projection;
			return ref?.$el || ref || this.$el;
			},
			async _enterFullscreen(el) {
			const anyEl = el;
			if (anyEl.requestFullscreen)              return anyEl.requestFullscreen();
			if (anyEl.webkitRequestFullscreen)        return anyEl.webkitRequestFullscreen();
			if (anyEl.msRequestFullscreen)            return anyEl.msRequestFullscreen();
			this.$toast && this.$toast.error?.('Pantalla completa no soportada en este navegador');
			},

		async _exitFullscreen() {
			const anyDoc = document;
			if (document.exitFullscreen)              return document.exitFullscreen();
			if (anyDoc.webkitExitFullscreen)          return anyDoc.webkitExitFullscreen();
			if (anyDoc.msExitFullscreen)              return anyDoc.msExitFullscreen();
		},

		async extenderPantalla() {
			const ref = this.$refs.fsRoot;
			const el = ref?.$el || ref;

			if (!el) return;

			const isFs = !!(document.fullscreenElement ||
							document.webkitFullscreenElement ||
							document.msFullscreenElement);

			try {
				if (!isFs) {
				await this._enterFullscreen(el);  // usa tu helper con prefijos
				} else {
				await this._exitFullscreen();
				}
			} finally {
				// actualiza estado
				this.isFullscreen = !!(document.fullscreenElement ||
									document.webkitFullscreenElement ||
									document.msFullscreenElement);
			}
		},
		_calcChartHeight() {
			const rootRef = this.$refs.fsRoot;
			const root = rootRef?.$el || rootRef;
			if (!root) return 500;
			const projection = this._projectionEl();
			const chartWrap = projection?.querySelector?.('.apexchart-padding');

			const headerRef = this.$refs.fsHeader;
			const header = headerRef?.$el || headerRef;

			// alto total disponible
			let rootH = root.getBoundingClientRect().height;
			if (rootH < 120) {
				const parentH = root.parentElement?.getBoundingClientRect?.().height || 0;
				if (parentH > rootH) rootH = parentH;
			}
			if (this.isFullscreen && rootH < 120) {
				rootH = Math.max(rootH, window.innerHeight || 0);
			}

			// alto del header (botón)
			const headerH = header ? header.getBoundingClientRect().height : 0;

			// padding/márgenes extra (mt-2, padding interno, etc.)
			const styles = window.getComputedStyle(root);
			const padTop = parseFloat(styles.paddingTop || "0") || 0;
			const padBot = parseFloat(styles.paddingBottom || "0") || 0;
			const safety = 10;

			let h;
			if (projection && chartWrap) {
				const pRect = projection.getBoundingClientRect();
				const cRect = chartWrap.getBoundingClientRect();
				const cStyles = window.getComputedStyle(chartWrap);
				const cPadTop = parseFloat(cStyles.paddingTop || "0") || 0;
				const cPadBot = parseFloat(cStyles.paddingBottom || "0") || 0;
				const topUsed = Math.max(0, cRect.top - pRect.top);
				h = Math.max(320, Math.floor(pRect.height - topUsed - cPadTop - cPadBot - safety));
			} else {
				h = Math.max(320, Math.floor(rootH - headerH - padTop - padBot - safety));
			}

			// Limitar el alto máximo en pantalla completa
			if (this.isFullscreen) {
				h = Math.min(h, 950); // máximo en pantalla completa
			}
			return h;
		},

		_applyChartSize() {
				const rootRef = this.$refs.fsRoot;
				const root = rootRef?.$el || rootRef;
				if (!root) return;

				const rect = root.getBoundingClientRect();
				if (rect.width < 100 || rect.height < 120) return; // evita recalcular cuando el tab está oculto

				this.chartHeight = this._calcChartHeight();
				if (this.chartOptions?.chart) {
					this.chartOptions.chart.height = this.chartHeight;
				}

				// ApexCharts a veces requiere resize manual
				this.$nextTick(() => {
				const comp = this.$refs.apex;
				const chartObj = comp?.chart || comp?.chartObj;
				chartObj?.resize?.();
				requestAnimationFrame(() => chartObj?.resize?.());
				});
		},
	},
};
</script>
<style scoped>
/* Padding extra para asegurar visibilidad de labels del eje X */
.apexchart-padding {
	padding-bottom: 40px;
}
.historial-table tbody tr:nth-child(odd) {
  background: #fafafa;
}
.historial-table tbody tr:hover {
  background: #f1f5ff;
}

.sticky-dia {
  position: sticky;
  left: 0;
  z-index: 2;
  background: white; /* importante para que no se transparente */
  min-width: 120px;
  max-width: 160px;
}

/* evita que los headers/celdas se corten raro */
.historial-table th,
.historial-table td {
  white-space: nowrap;
}

.total-row td {
  font-weight: 700;
}

/* 1) el wrapper interno de Vuetify: */
.mx-detalle-table .v-data-table__wrapper{
  overflow-x: auto !important;  /* ✅ siempre visible */
  overflow-y: auto !important;    /* mantiene scroll vertical usable */
}

.mx-xscroll-sticky{
position: sticky;
bottom: 0;
z-index: 5;
background: white;          /* o el color de tu card */
border-top: 1px solid rgba(0,0,0,0.08);
height: 18px;               /* alto del scrollbar */
overflow-x: auto;
overflow-y: hidden;
}

.mx-xscroll-inner{
  height: 1px;                /* solo para crear ancho scrolleable */
}

.mx-fecha-cell {
	font-size: 14px;       /* o 0.875rem */
	line-height: 1.2;
	white-space: nowrap;
}
.fs-surface {
  background: #fff;   /* o el color que quieras */
  min-height: 60vh;  /* para que “llene” fullscreen */
  height: 100%;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.projection-wrap {
  height: 100%;
  min-height: 0;
}

::v-deep .fs-surface {
  background: #fff;
  min-height: 60vh;
}

::v-deep .titulo-area {
  font-size: 20px;
}

::v-deep .apexcharts-xaxis text {
  font-size: 26px !important;
  font-weight: 700 !important;
}

::v-deep .apexcharts-data-labels text {
  font-size: 20px !important;
  font-weight: 700 !important;
}

.titulo-fechas{
  font-size: 14px;
  opacity: 0.85;
}

</style>